export default {
  filtersContainerPaddingY: '$6',
  filtersContainerPaddingX: '$2',
  moreOptionsTextTransform: 'uppercase' as const,
  titleLineHeight: 1.2,
};
